<!-- START KITS SECTION -->
<ng-container>
  <app-banner2 *ngIf="kit" [title]="firstBannerData.title" [id]="'label_fragment_kit' | translate"
               [description]="firstBannerData.content"
               [img]="firstBannerData.image.path"></app-banner2>
  <div class="container" *ngIf="kit">
    <div class="row spacer-kit">
      <div class="col-60 d-md-none ">
        <div class="swiper-container" [swiper]="config">
          <div class="swiper-wrapper">
            <div class="swiper-slide" *ngFor="let item of kit">
              <app-box-kit [serie]="'label_kit' | translate" [name]="item.name"
                           [phiInfo]="item.phy_info" [slug]="item.name_slug"
                           [img]="item.image_header.path"></app-box-kit>
            </div>
          </div>
          <div class="swiper-pagination swiper-pagination-elsa swiper-pagination-lite swiper-pagination-products"></div>
        </div>
      </div>
      <div class="col-30 col-lg-20 d-none d-md-flex spacer-kit-item" *ngFor="let item of kit">
        <app-box-kit [serie]="'label_kit' | translate" [name]="item.name"
                     [phiInfo]="item.phy_info" [slug]="item.name_slug"
                     [img]="item.image_header.path"></app-box-kit>
      </div>
    </div>
  </div>
</ng-container>
<!-- END KITS SECTION -->

<!-- START ACCESSORIES SECTION -->
<ng-container
  *ngIf="(accessoriesWithCategories && accessoriesWithCategories.length) || (machineFilters  && hasFilters)">
  <app-banner2 [title]="secondaryBannerData.title" [id]="'label_fragment_accessories' | translate"
               [img]="secondaryBannerData.image.path" [description]="secondaryBannerData.content"></app-banner2>
  <div class="container">
    <!-- START ACCESSORIES FILTER -->
    <div *ngIf="!hideFilterControl">
      <h5 class="pt-5 label-accessories text-uppercase">{{'label_filter_for_machines_the_accessories' | translate}}</h5>
      <form [formGroup]=formGroup>

        <!-- START DESKTOP FILTERS -->
        <div class="d-lg-block d-none">
          <div class="row">
            <div class="col-20 form-group">
              <select formControlName="category_slug"
                      class="custom-select form-control form-control-elsa accessories-selector">
                <option class="form-option-elsa" value="">{{'form_select_category' | translate}}</option>
                <option *ngFor="let category of categoryFilters" [value]="category">{{category}}</option>
              </select>
            </div>

            <div class="col-20 form-group">
              <select formControlName="machine_slug"
                      class="custom-select form-control form-control-elsa accessories-selector">
                <option class="form-option-elsa" value="">{{'form_select_model' | translate}}</option>
                <option *ngFor="let machine of machineFilters" [value]="machine.name_slug">{{machine.name}}</option>
              </select>
            </div>

            <div class="col-10 form-group">
              <button class="text-uppercase btn btn-gray w-80 accessories-button" type="submit"
                      (click)="searchAccessories()">
                {{'label_search' | translate}}
              </button>
            </div>

            <div class="col-10 form-group">
              <button class="text-uppercase btn btn-outline-gray w-80 accessories-button" type="submit"
                      (click)="resetAccessories()">
                {{'label_reset' | translate}}
              </button>
            </div>
          </div>
        </div>
        <!-- END DESKTOP FILTERS -->

        <!-- START MOBILE FILTERS -->
        <div class="d-lg-none d-block pb-md-5 pb-sm-5">
          <div class="row">
            <div class="col-60 form-group">
              <select formControlName="category_slug"
                      class="custom-select form-control form-control-elsa accessories-selector">
                <option class="form-option-elsa" value="">{{'form_select_category' | translate}}</option>
                <option *ngFor="let category of categoryFilters" [value]="category">{{category}}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-60 form-group">
              <select formControlName="machine_slug"
                      class="custom-select form-control form-control-elsa accessories-selector">
                <option class="form-option-elsa" value="">{{'form_select_model' | translate}}</option>
                <option *ngFor="let machine of machineFilters" [value]="machine.name_slug">{{machine.name}}</option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="col-30 form-group">
              <button class="text-uppercase btn btn-gray w-100 accessories-button" type="submit"
                      (click)="searchAccessories()">
                {{'label_search' | translate}}
              </button>
            </div>

            <div class="col-30 form-group">
              <button class="text-uppercase btn btn-outline-gray w-100 accessories-button" type="submit"
                      (click)="resetAccessories()">
                {{'label_reset' | translate}}
              </button>
            </div>
          </div>

        </div>
        <!-- END MOBILE FILTERS -->

      </form>
    </div>
    <!-- END ACCESSORIES FILTER -->

    <!-- START PADDING WHEN HIDING FILTER -->
    <div class="spacer-accessories-hidden-filter" *ngIf="hideFilterControl"></div>
    <!-- END PADDING WHEN HIDING FILTER -->

    <!-- START ACCESSORIES SWIPER CAROUSEL -->
    <div class="col-60 d-md-none">
      <div class="swiper-container" [swiper]="config">
        <div class="swiper-wrapper">
          <div class="swiper-slide" *ngFor="let item of accessoriesToShow">
            <app-box-accessory [title]='item.name' [categoryId]='item.categoryId' [img]='item.image_header.path' [code]='item.sku'
                               [description]="item.products | implode: 'name':' / '"></app-box-accessory>
          </div>
        </div>
        <div class="swiper-pagination swiper-pagination-elsa swiper-pagination-lite swiper-pagination-products"></div>
      </div>
    </div>
    <!-- END ACCESSORIES SWIPER CAROUSEL -->

    <!-- START ACCESSORIES GRID -->
    <div class="row pt-lg-5 mt-lg-5">
      <div class="col-30 col-lg-20 d-none d-md-flex my-4" *ngFor="let item of accessoriesToShow">
        <app-box-accessory [title]='item.name' [categoryId]='item.categoryId' [img]='item.image_header.path' [code]='item.sku'
                           [description]="item.products | implode: 'name':' / '"></app-box-accessory>
      </div>
    </div>
    <!-- END ACCESSORIES GRID -->
  </div>
</ng-container>
<!-- END ACCESSORIES SECTION -->
